<section class="pricing-cta" aria-label="Call to action">
  <div class="cta-panel">
    <img src="images/webps/three.png" class="three-top" alt="" aria-hidden="true" />
    <img src="images/webps/three.png" class="three-bottom" alt="" aria-hidden="true" />

    <div class="cta-content">
      <h2>
        Scale Smarter With
        <span>orderYaa ERP</span>
      </h2>
      <p>
        Built to simplify workflows, improve productivity, and
        <br />
        help modern businesses grow faster.
      </p>

      <div class="cta-actions">
        <a routerLink="/product" class="btn-primary">Start free trial</a>
        <a href="https://calendly.com/tahir-aslam-techcolleagues/meeting-with-tahir-aslam-founder-tech-colleagues?month=2026-07" target="_blank" rel="noopener noreferrer" class="btn-secondary">Talk to experts</a>
      </div>
    </div>
  </div>
</section>